import "./index.css";
import '@fontsource/special-elite';

import { main } from "./app.gleam";

document.addEventListener("DOMContentLoaded", main)
